import { Link } from "react-router-dom";
import { Warning } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { formatCurrency } from "@/lib/format";
import { VIEW_OPTIONS } from "./constants";

export function MetaItem({ icon, label, value, testId }) {
  return (
    <div data-testid={testId}>
      <div className="text-[10px] font-semibold uppercase tracking-[0.18em] text-slate-500 flex items-center gap-1.5">
        <span className="text-[#327de3]">{icon}</span>
        {label}
      </div>
      <div className="mt-1 font-display text-base font-semibold text-slate-900 tabular-nums">{value}</div>
    </div>
  );
}

export function SubMetric({ label, value }) {
  return (
    <div>
      <div className="text-[10px] font-semibold uppercase tracking-[0.15em] text-slate-400">{label}</div>
      <div className="mt-0.5 text-sm font-semibold text-slate-700 tabular-nums">{formatCurrency(value)}</div>
    </div>
  );
}

export function StatusPill({ status }) {
  const s = (status || "").trim();
  const lower = s.toLowerCase();
  let cls = "bg-slate-100 text-slate-600";
  let text = s || "Remaining";
  if (lower.includes("closed")) { cls = "bg-emerald-100 text-emerald-700"; text = "Closed"; }
  else if (lower.includes("contract")) { cls = "bg-amber-100 text-amber-800"; text = "In Contract"; }
  else if (!s) { cls = "bg-slate-100 text-slate-500"; text = "Remaining"; }
  return (
    <span className={`inline-flex items-center px-1.5 sm:px-2 py-0.5 rounded-full text-[9px] sm:text-[11px] font-semibold whitespace-nowrap ${cls}`}>
      {text}
    </span>
  );
}

export function ViewTabs({ view, onChange }) {
  return (
    <div className="inline-flex items-center gap-1 rounded-lg bg-[#327de3]/10 p-1" data-testid="view-tabs">
      {VIEW_OPTIONS.map((opt) => {
        const active = view === opt.key;
        return (
          <button
            key={opt.key}
            onClick={() => onChange(opt.key)}
            data-testid={`view-tab-${opt.key}`}
            className={`px-2.5 sm:px-3 py-1 text-[11px] sm:text-xs font-semibold uppercase tracking-widest rounded-md transition-colors ${
              active ? "bg-[#327de3] text-white shadow-sm" : "text-[#1f64c2] hover:bg-[#327de3]/15"
            }`}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}

export function NoSource({ title, error }) {
  return (
    <div className="bg-white rounded-xl border border-dashed border-slate-300 p-10 text-center" data-testid="no-source">
      <Warning size={28} className="text-amber-500 mx-auto" />
      <h3 className="mt-3 font-display text-base font-semibold text-slate-800">
        {error ? `Couldn't load ${title}` : `No ${title} data`}
      </h3>
      <p className="mt-1 text-sm text-slate-500">
        {error || `Add a Google Sheet URL for ${title} in business settings, then refresh.`}
      </p>
      <Link to="/businesses" className="inline-block mt-4">
        <Button variant="outline" className="border-slate-300">Manage business</Button>
      </Link>
    </div>
  );
}

export function MoneyTooltip({ active, payload, label }) {
  if (!active || !payload?.length) return null;
  return (
    <div className="bg-white border border-slate-200 shadow-lg rounded-md px-3 py-2 text-xs">
      <div className="font-semibold text-slate-800 mb-1">{label || payload[0]?.name}</div>
      {payload.map((p, i) => (
        <div key={i} className="flex items-center justify-between gap-3">
          <span className="flex items-center gap-1.5">
            <span className="w-2 h-2 rounded-sm" style={{ background: p.color }} />
            <span className="text-slate-600">{p.name}</span>
          </span>
          <span className="font-semibold text-slate-900 tabular-nums">{formatCurrency(p.value)}</span>
        </div>
      ))}
    </div>
  );
}
